import { render, staticRenderFns } from "./NotesModalList.vue?vue&type=template&id=55a87ada&"
import script from "./NotesModalList.vue?vue&type=script&lang=js&"
export * from "./NotesModalList.vue?vue&type=script&lang=js&"
import style0 from "./NotesModalList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports